(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/top-badge.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/top-badge.js');
"use strict";


const TopBadge = _ref => {
  let label = _ref.label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'red' : _ref$color;
  return React.createElement("div", {
    className: "bingo-card-top-badge bingo-card-top-badge--".concat(color)
  }, label);
};
setGlobal('svs.bingo_react.components.bingoCard.TopBadge', TopBadge);

 })(window);